import { render, staticRenderFns } from "./setTimezone.vue?vue&type=template&id=82789d44"
import script from "./setTimezone.vue?vue&type=script&lang=ts"
export * from "./setTimezone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports